// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════
   PanelCorrelaciones
   ═══════════════════════════════════════════════ */
.pc-panel {
  position: relative;
  top: 15%;
  /* right: 3%; */
  z-index: 10;

  width: 252px;
  background: #ffffff;
  border: 1.5px solid var(--second-color);
  border-radius: 12px;
  overflow: hidden;
  font-family: sans-serif;
  font-size: 13px;
  color: #1a1a1a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);
}

/* ── Header ─────────────────────────────────────── */
.pc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  cursor: pointer;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);
  -webkit-user-select: none;
          user-select: none;
}
.pc-header:hover {
  background: rgba(0, 0, 0, 0.03);
}
.pc-title {
  font-size: 13px;
  font-weight: 500;
  color: #1a1a1a;
}
.pc-header-right {
  display: flex;
  align-items: center;
  gap: 6px;
}
.pc-count-badge {
  background: #E6F1FB;
  color: #185FA5;
  font-size: 10px;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 6px;
}
.pc-toggle {
  font-size: 14px;
  color: #888;
  line-height: 1;
}

/* ── Hint ────────────────────────────────────────── */
.pc-hint {
  padding: 5px 14px;
  font-size: 11px;
  color: #888;
  background: #fafafa;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.06);
  line-height: 1.4;
}

/* ── Cuerpo ──────────────────────────────────────── */
.pc-body {
  padding: 10px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* ── Lista de relaciones ─────────────────────────── */
.pc-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-height: 180px;
  overflow-y: auto;
}
.pc-list::-webkit-scrollbar       { width: 3px; }
.pc-list::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.15); border-radius: 2px; }

.pc-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 6px 10px;
}
.pc-item-label {
  font-size: 11px;
  color: #333;
  line-height: 1.4;
  flex: 1 1;
}
.pc-item-delete {
  background: none;
  border: none;
  color: #aaa;
  cursor: pointer;
  font-size: 12px;
  padding: 0 2px;
  flex-shrink: 0;
  transition: color 0.15s;
}
.pc-item-delete:hover { color: #E24B4A; }

.pc-empty {
  font-size: 11px;
  color: #aaa;
  text-align: center;
  margin: 4px 0;
}

/* ── Formulario ──────────────────────────────────── */
.pc-form {
  display: flex;
  flex-direction: column;
  gap: 7px;
  border-top: 0.5px solid rgba(0, 0, 0, 0.07);
  padding-top: 10px;
}
.pc-field {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.pc-label {
  font-size: 11px;
  color: #888;
}
.pc-select {
  background: #f5f5f5;
  color: #1a1a1a;
  border: 0.5px solid rgba(0, 0, 0, 0.14);
  border-radius: 8px;
  padding: 7px 10px;
  font-size: 12px;
  width: 100%;
  cursor: pointer;
  outline: none;
  appearance: auto;
}
.pc-select:focus {
  border-color: rgba(24, 95, 165, 0.5);
  box-shadow: 0 0 0 3px rgba(24, 95, 165, 0.1);
}

/* ── Botón crear ─────────────────────────────────── */
.pc-btn-crear {
  background: #185FA5;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px;
  font-size: 12px;
  font-weight: 500;
  width: 100%;
  cursor: pointer;
  transition: opacity 0.15s, transform 0.1s;
  margin-top: 2px;
}
.pc-btn-crear:hover  { opacity: 0.88; }
.pc-btn-crear:active { transform: scale(0.97); }
`, "",{"version":3,"sources":["webpack://./src/components/styles/PanelCorrelaciones.css"],"names":[],"mappings":"AAAA;;oDAEoD;AACpD;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,WAAW;;EAEX,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,yCAAyC;AAC3C;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,8CAA8C;EAC9C,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;AACA,oCAAoC,UAAU,EAAE;AAChD,oCAAoC,4BAA4B,EAAE,kBAAkB,EAAE;;AAEtF;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,SAAO;AACT;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,uBAAuB;AACzB;AACA,wBAAwB,cAAc,EAAE;;AAExC;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,2CAA2C;EAC3C,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,uCAAuC;EACvC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yCAAyC;EACzC,eAAe;AACjB;AACA,uBAAuB,aAAa,EAAE;AACtC,uBAAuB,sBAAsB,EAAE","sourcesContent":["/* ═══════════════════════════════════════════════\r\n   PanelCorrelaciones\r\n   ═══════════════════════════════════════════════ */\r\n.pc-panel {\r\n  position: relative;\r\n  top: 15%;\r\n  /* right: 3%; */\r\n  z-index: 10;\r\n\r\n  width: 252px;\r\n  background: #ffffff;\r\n  border: 1.5px solid var(--second-color);\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  font-family: sans-serif;\r\n  font-size: 13px;\r\n  color: #1a1a1a;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);\r\n}\r\n\r\n/* ── Header ─────────────────────────────────────── */\r\n.pc-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 14px;\r\n  cursor: pointer;\r\n  border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);\r\n  user-select: none;\r\n}\r\n.pc-header:hover {\r\n  background: rgba(0, 0, 0, 0.03);\r\n}\r\n.pc-title {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: #1a1a1a;\r\n}\r\n.pc-header-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n.pc-count-badge {\r\n  background: #E6F1FB;\r\n  color: #185FA5;\r\n  font-size: 10px;\r\n  font-weight: 500;\r\n  padding: 2px 6px;\r\n  border-radius: 6px;\r\n}\r\n.pc-toggle {\r\n  font-size: 14px;\r\n  color: #888;\r\n  line-height: 1;\r\n}\r\n\r\n/* ── Hint ────────────────────────────────────────── */\r\n.pc-hint {\r\n  padding: 5px 14px;\r\n  font-size: 11px;\r\n  color: #888;\r\n  background: #fafafa;\r\n  border-bottom: 0.5px solid rgba(0, 0, 0, 0.06);\r\n  line-height: 1.4;\r\n}\r\n\r\n/* ── Cuerpo ──────────────────────────────────────── */\r\n.pc-body {\r\n  padding: 10px 14px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n/* ── Lista de relaciones ─────────────────────────── */\r\n.pc-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n  max-height: 180px;\r\n  overflow-y: auto;\r\n}\r\n.pc-list::-webkit-scrollbar       { width: 3px; }\r\n.pc-list::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.15); border-radius: 2px; }\r\n\r\n.pc-item {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  background: #f5f5f5;\r\n  border-radius: 8px;\r\n  padding: 6px 10px;\r\n}\r\n.pc-item-label {\r\n  font-size: 11px;\r\n  color: #333;\r\n  line-height: 1.4;\r\n  flex: 1;\r\n}\r\n.pc-item-delete {\r\n  background: none;\r\n  border: none;\r\n  color: #aaa;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  padding: 0 2px;\r\n  flex-shrink: 0;\r\n  transition: color 0.15s;\r\n}\r\n.pc-item-delete:hover { color: #E24B4A; }\r\n\r\n.pc-empty {\r\n  font-size: 11px;\r\n  color: #aaa;\r\n  text-align: center;\r\n  margin: 4px 0;\r\n}\r\n\r\n/* ── Formulario ──────────────────────────────────── */\r\n.pc-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 7px;\r\n  border-top: 0.5px solid rgba(0, 0, 0, 0.07);\r\n  padding-top: 10px;\r\n}\r\n.pc-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n}\r\n.pc-label {\r\n  font-size: 11px;\r\n  color: #888;\r\n}\r\n.pc-select {\r\n  background: #f5f5f5;\r\n  color: #1a1a1a;\r\n  border: 0.5px solid rgba(0, 0, 0, 0.14);\r\n  border-radius: 8px;\r\n  padding: 7px 10px;\r\n  font-size: 12px;\r\n  width: 100%;\r\n  cursor: pointer;\r\n  outline: none;\r\n  appearance: auto;\r\n}\r\n.pc-select:focus {\r\n  border-color: rgba(24, 95, 165, 0.5);\r\n  box-shadow: 0 0 0 3px rgba(24, 95, 165, 0.1);\r\n}\r\n\r\n/* ── Botón crear ─────────────────────────────────── */\r\n.pc-btn-crear {\r\n  background: #185FA5;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 8px;\r\n  padding: 8px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  width: 100%;\r\n  cursor: pointer;\r\n  transition: opacity 0.15s, transform 0.1s;\r\n  margin-top: 2px;\r\n}\r\n.pc-btn-crear:hover  { opacity: 0.88; }\r\n.pc-btn-crear:active { transform: scale(0.97); }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
